<script>
    import { fly } from "svelte/transition";

    import { isObjectEmpty } from "../../../Utils/utilFunctions.svelte";

    import { PageLoading } from "../../../Components/Common/index.svelte";

    import EditSection from "../../PatientEncounter/components/EditSection.svelte";
    import CreateSection from "../../PatientEncounter/components/CreateSection.svelte";

    export let encounterProps = {};
    export let closeExpandSidePanel = () => {};

    $: isPanelForNewEncounter = !encounterProps.hasOwnProperty("id");

    $: if (isObjectEmpty(encounterProps)) {
        viewEncounterId = null;
        calendarSidePanelProps = {};
    }

    $: if (
        encounterProps.id &&
        (!viewEncounterId || encounterProps.prevId == viewEncounterId)
    )
        initCalendarSidePanelProps();

    let viewEncounterId;

    let isLoadingEncounter = false;

    let calendarSidePanelProps = {};

    const initCalendarSidePanelProps = () => {
        isLoadingEncounter = true;

        calendarSidePanelProps = {
            afterSaveEncounter: () => closeExpandSidePanel(true),
        };

        isLoadingEncounter = false;
    };
</script>

{#if !isObjectEmpty(encounterProps)}
    <div
        class="flex flex-col side-panel-container flex-1 bg-white p-4"
        transition:fly={{ duration: 150, x: 500 }}
    >
        <div class="flex w-full items-center justify-end">
            <button
                class="btn btn-circle bg-neutral btn-sm"
                on:click={closeExpandSidePanel}
            >
                <i class="fa fa-times" aria-hidden="true"></i>
            </button>
        </div>

        <div class="flex flex-1 flex-col overflow-y-auto">
            {#if isPanelForNewEncounter}
                <CreateSection
                    isViewInDailyCalendarSidePanel
                    calendarSidePanelProps={encounterProps}
                />
            {:else if isLoadingEncounter}
                <PageLoading />
            {:else}
                <EditSection
                    patientEncounterId={encounterProps.id}
                    isViewInDailyCalendarSidePanel
                    {calendarSidePanelProps}
                    isEditDuplicate={encounterProps.hasOwnProperty(
                        "isDuplicate",
                    ) && encounterProps.isDuplicate}
                    fromSidePanel
                />
            {/if}
        </div>
    </div>
{/if}

<style>
    .side-panel-container {
        position: absolute;
        right: 0px;
        left: auto;
        top: 0;
        bottom: 0px;
        width: 100%;
        /* width: 50vw; */
        z-index: 999;
    }
</style>
